import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { environment } from '../../../environments/environment';

import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { GoogleReviewModalComponent } from '../google-review-modal/google-review-modal.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-purchase-upgrades',
  templateUrl: './new-purchase-upgrades.component.html',
  styleUrls: ['./new-purchase-upgrades.component.scss'],
})
export class NewPurchaseUpgradesComponent implements OnInit {
  total_txn: number = 0;
  formGroup: FormGroup;
  editFG: FormGroup;
  transactions: any;
  private modalRef;
  google_feedbacks: any;
  edit_google_feedbacks: any;
  edit_google_review: any;
  url_names: any;
  reviewData: any;
  get_all_feedback_URL: any;
  imagepreview: any;
  imgUrl = environment.ImageUrl;
  googlecoundata: any;


  constructor(
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private router: Router,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }
  closeResult = '';

  ngOnInit(): void {
    this.get_all_url_names();
    // this.deduct_credits_transactions();
    this.vip_token_transactions();
    this.get_feedback_subadmin_google();

    this.editFG = new FormGroup({
      feedbackNameurl: new FormControl(''),
      feedbackName: new FormControl(''),
      description: new FormControl(''),
      star: new FormControl(''),
    });
  }

  deduct_credits_transactions() {
    let formData = new FormData();
    formData.append('type', '1');
    this.auth.deduct_credits_transactions(formData).subscribe(
      (response: any) => {
        this.transactions = response.body;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  vip_token_transactions() {
    this.auth.vip_token_transactions().subscribe(
      (response: any) => {
        this.transactions = response.body.transactions;
        this.total_txn = response.body.available;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  deduct_credits(credits, reviews) {
    Swal.fire({
      title: 'Are you sure?',
      text: `${credits} credits will be deducted from your VIP Tokens.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, deduct it!',
    }).then((result) => {
      if (result.isConfirmed) {
        let formData = new FormData();
        formData.append('tokens', credits);
        formData.append('type', '1');
        formData.append('reviews', reviews);

        this.auth.deduct_credits(formData).subscribe(
          (response: any) => {
            Swal.fire('Done!', response.message, 'success');
            this.ngOnInit()
          },
          (error) => {
            if (error.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            }
            Swal.fire('Warning!', error.error.message, 'warning');
          }
        );

      }
    });
  }

  view_all_transactions(modal) {
    this.modalRef = this.modalService.open(modal, {
      size: 'md',
      ariaLabelledBy: 'modal-basic-title',
    });
  }

  open_google_review_modal() {
    this.modalService.open(GoogleReviewModalComponent, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'v2_login_model',
    });
  }

  get_feedback_subadmin_google() {
    this.auth.get_feedback_subadmin_google(0).subscribe(
      (response: any) => {
        this.google_feedbacks = response.body;
        this.googlecoundata = this.google_feedbacks.length
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }
  editReview(content, id, contentdata) {
    this.edit_google_review = id;
    this.auth.edit_feedback_subadmin_google(id).subscribe(
      (response: any) => {
        this.edit_google_feedbacks = response.body.edit_feedback_subadmin_google;
        this.reviewData = response.body.data
     
        this.modalService.open(content, {
          backdropClass: 'light-blue-backdrop',
          size: 'sm',
          // backdrop: 'static',
        });
        
        let data = this.edit_google_feedbacks.feedbackNameurl == null ? this.url_names[0]?.url_name : this.edit_google_feedbacks.feedbackNameurl
        this.onChange(data)
        // console.log(this.get_all_feedback_URL==undefined?"":this.get_all_feedback_URL[0].description,'==11111111hereeeeeeeeeeeeeeeeeee');
        let newdesc=this.get_all_feedback_URL==undefined?"":this.get_all_feedback_URL[0].description

        this.editFG.patchValue({
          feedbackNameurl: this.edit_google_feedbacks.feedbackNameurl == null ? this.url_names[0]?.url_name : this.edit_google_feedbacks.feedbackNameurl,
          feedbackName: this.edit_google_feedbacks.feedbackName,
          description: this.edit_google_feedbacks.description != null ? this.edit_google_feedbacks.description : newdesc,
          star: this.edit_google_feedbacks.star == 0 ? 5 : this.edit_google_feedbacks.star,
        });

        // const fillData = this.modalService.open(GoogleReviewModalComponent, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'v2_login_model' })
        // fillData.componentInstance.edit_review_data = this.edit_google_feedbacks;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }
  update_edit_google_feedbacks() {
    this.auth
      .update_edit_google_feedbacks(this.editFG.value, this.edit_google_review)
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.ngOnInit();
          this.modalService.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }
  get_all_url_names() {
    this.auth.get_feedback_manager_url().subscribe(
      (response: any) => {
        this.url_names = response.body;
        // console.log(this.url_names,'========================================');

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  onChange(event) {
    let formData = new FormData();
    formData.append('current_module', event);
    this.auth.get_all_feedback_module(formData).subscribe((response: any) => {
      (response)
      this.get_all_feedback_URL = response.body
    });
  }

  subonChange(data) {
    this.editFG.patchValue({
      description: data
    })
  }


  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  verify_review(id) {
    this.auth.verify_feedback_subadmin_google(id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.ngOnInit();
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  viewlimage(content: string, id) {
    this.getimagdata(id)
    this.modalService.open(content, { size: 'sm', backdrop: 'static' });
    // this.verify_review(id)


  }

  getimagdata(id) {
    this.auth.get_feedbackimagedata(id).subscribe(
      (response: any) => {
        // console.log(response,'==hereeeeeeeeee');
        this.imagepreview = response.body.image
        // console.log(this.imagepreview);


        // this.subAdmainName = response.body;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }
}
